/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import angular from "angular"

angular
  .module("uCountitUiApp")

  .factory("SpaceSrv", function ($rootScope, $resource) {
    return $resource(
      $rootScope.globalConfig.apipath + "/space/:id",
      { id: this.id },
      {
        update: {
          method: "PUT",
        },
      }
    )
  })
